import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(public snackBar: MatSnackBar) {}

  /**
   *
   * @param message message @{string} field
   * @param duration duration of delay, snackbar will remain on given time default time 3sec
   * @param horizontalPosition adjust horizontal position of snackbar given string those string values
   *  | 'start' | 'center' | 'end' | 'left' | 'right'  default start
   * @param verticalPosition adjust vertical position of snackbar given string those string values
   *  'top' | 'bottom' = 'bottom'  default bottom
   * @param snackBarVariant panel class and type adjust
   * @returns this will executed not return anything
   */
  showError(
    message: string,
    duration: number = 5000,
    horizontalPosition: 'start' | 'center' | 'end' | 'left' | 'right' = 'start',
    verticalPosition: 'top' | 'bottom' = 'bottom',
    snackBarVariant: string = 'error'
  ): void {
    const snackType = snackBarVariant;
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration,
      horizontalPosition,
      verticalPosition,
      panelClass: [`snackbar-box`, `snack-${snackType}`],
      data: { message, snackType, snackBar: snackType },
    });
  }

  /**
   *
   * @param message message @{string} field
   * @param duration duration of delay, snackbar will remain on given time default time 3sec
   * @param horizontalPosition adjust horizontal position of snackbar given string those string values
   *  | 'start' | 'center' | 'end' | 'left' | 'right'  default start
   * @param verticalPosition adjust vertical position of snackbar given string those string values
   *  'top' | 'bottom' = 'bottom'  default bottom
   * @param snackBarVariant panel class and type adjust
   * @returns this will executed not return anything
   */
  showSuccess(
    message: string,
    duration: number = 5000,
    horizontalPosition: 'start' | 'center' | 'end' | 'left' | 'right' = 'start',
    verticalPosition: 'top' | 'bottom' = 'bottom',
    snackBarVariant: string = 'success'
  ): void {
    const snackType = snackBarVariant;
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration,
      horizontalPosition,
      verticalPosition,
      panelClass: [`snackbar-box`, `snack-${snackType}`],
      data: { message, snackType, snackBar: snackType },
    });
  }

  /**
   *
   * @param message message @{string} field
   * @param duration duration of delay, snackbar will remain on given time default time 3sec
   * @param horizontalPosition adjust horizontal position of snackbar given string those string values
   *  | 'start' | 'center' | 'end' | 'left' | 'right'  default start
   * @param verticalPosition adjust vertical position of snackbar given string those string values
   *  'top' | 'bottom' = 'bottom'  default bottom
   * @param snackBarVariant panel class and type adjust
   * @returns this will executed not return anything
   */
  showWarning(
    message: string,
    duration: number = 5000,
    horizontalPosition: 'start' | 'center' | 'end' | 'left' | 'right' = 'start',
    verticalPosition: 'top' | 'bottom' = 'bottom',
    snackBarVariant: string = 'warn'
  ): void {
    const snackType = snackBarVariant;
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration,
      horizontalPosition,
      verticalPosition,
      panelClass: [`snackbar-box`, `snack-${snackType}`],
      data: { message, snackType, snackBar: snackType },
    });
  }

  /**
   *
   * @param message message @{string} field
   * @param duration duration of delay, snackbar will remain on given time default time 3sec
   * @param horizontalPosition adjust horizontal position of snackbar given string those string values
   *  | 'start' | 'center' | 'end' | 'left' | 'right'  default start
   * @param verticalPosition adjust vertical position of snackbar given string those string values
   *  'top' | 'bottom' = 'bottom'  default bottom
   * @param snackBarVariant panel class and type adjust
   * @returns this will executed not return anything
   */
  showInfo(
    message: string,
    duration: number = 5000,
    horizontalPosition: 'start' | 'center' | 'end' | 'left' | 'right' = 'start',
    verticalPosition: 'top' | 'bottom' = 'bottom',
    snackBarVariant: string = 'info'
  ): void {
    const snackType = snackBarVariant;
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration,
      horizontalPosition,
      verticalPosition,
      panelClass: [`snackbar-box`, `snack-${snackType}`],
      data: { message, snackType, snackBar: snackType },
    });
  }
}
